import React, { FC } from "react";
import Tippy, { type TippyProps } from "@tippyjs/react";

import "./externalStyles.scss";

export interface TippyTooltipProps extends Omit<TippyProps, "className" | "theme"> {
  customClassName?: string;
  isLightTheme?: boolean;
}

const TippyTooltip: FC<TippyTooltipProps> = ({
  children,
  visible,
  interactive,
  content = "",
  customClassName = "",
  isLightTheme = false,
  placement = "top",
  arrow = false,
  ...rest
}) => (
  <Tippy
    className={customClassName}
    content={content}
    theme={isLightTheme ? "light" : ""}
    placement={placement}
    arrow={arrow}
    visible={visible}
    interactive={interactive}
    {...rest}
  >
    {children}
  </Tippy>
);

/**
 * @deprecated Use tooltip from ./tooltip".
 */
export default TippyTooltip;
